export class LoadReferralsOfferAssigmenDetails {
  public static type: string = '[HTTP] LoadReferralsOfferAssigmenDetails';
  constructor(public payload: { id: number; active: boolean }) {}
}

export class LoadReferralsOfferAssignments {
  public static type: string = '[HTTP] LoadReferralsOfferAssignments';
}
